/**
 * The actor every permission gate reads: the session's actor while it is bound
 * to the organization this document is open on, and nothing otherwise. The
 * organization cell publishes a switch before the session has answered it, so
 * between the two the previous organization's actor would otherwise stand
 * beside the new one; read here, it reads unanswered and every gate closed.
 */
import { computed } from "@mhmo91/schmancy/state";
import { organizationId } from "../workspace/organization.state.ts";
import { session } from "./session.state.ts";

export const activeActor = computed(() => {
	const actor = session.value.actor;
	return actor !== null && actor.orgId === organizationId.value ? actor : null;
});
